import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SideBarService } from '@shared/UI/elements-ui/sidebar/sidebar.service';
import { SessionService } from '@utils/services/session.service';
import { CommonModule } from '@angular/common';
import { LogicalGrowthComponentsModule } from '@app/logical-growth-components/logical-growth-components.module';
import { NavbarProfileComponent } from '@shared/UI/elements-ui/navbar-profile/navbar-profile.component';
import { RateTableComponent } from '@shared/UI/elements-ui/rate-table/rate-table.component';

@Component({
  selector: 'navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    LogicalGrowthComponentsModule,
    RateTableComponent,
    NavbarProfileComponent,
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {

  public sidebarController = inject(SideBarService);
  public sessionService = inject(SessionService);

  private readonly _router = inject(Router);
  public reload(): void {
    window.location.reload();
  }

  public async logOut(): Promise<void> {
    await this._router.navigate(['']).then((): void => {
      window.location.reload();
    });
  }

  public toggleSidebar() {
    this.sidebarController.toggle();
  }
}
